import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";

export function GroupNameModal({
  isNewGroup,
  showModal,
  setShowModal,
  handleSaveGroupName,
  initialGroupName,
  groups,
}) {
  const [validated, setValidated] = useState(false);
  const [groupName, setGroupName] = useState(initialGroupName);

  const handleClose = () => setShowModal(false);

  const handleNameChange = (event) => {
    const { target } = event;
    setGroupName(target.value);
  };

  const handleSubmit = (event) => {
    const form = event.currentTarget;

    if (
      form.checkValidity() === false ||
      (
        groups.length &&
        groups.filter((group) => group.groupName === groupName).length
      )
    ) {
      event.preventDefault();
      event.stopPropagation();
      alert('You cannot have duplicate group names. Please rename your group.')
    } else {
      handleSaveGroupName(groupName);
    }
    setValidated(true);
  };

  return (
    <>
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>{`${
            isNewGroup ? `Create a` : `Edit`
          } Group`}</Modal.Title>
        </Modal.Header>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="groupName">
            <Modal.Body>
              <Form.Label>Group Name</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Group Name..."
                onChange={handleNameChange}
                autoFocus
                value={groupName}
              />
              <Form.Control.Feedback type="invalid">
                Group Name cannot be blank.
              </Form.Control.Feedback>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button type="submit">Save</Button>
            </Modal.Footer>
          </Form.Group>
        </Form>
      </Modal>
    </>
  );
}

export default GroupNameModal;
